<template>
  <div class="f-headers" id="headersWrapper">
    <language-header ref="languageHeader"></language-header>
    <main-header ref="mainHeader"></main-header>
  </div>
</template>

<script>
  import LanguageHeader from './LanguageHeader'
  import MainHeader from './MainHeader'

  export default {
    name: 'Headers',
    components: {MainHeader, LanguageHeader},
    methods: {
      stickyAndDisappear () {
        this.$refs.languageHeader.disappearBar()
        let header = document.getElementById('headersWrapper')
        let sticky = header.offsetTop
        if (window.pageYOffset > sticky) {
          header.classList.add('sticky')
          header.setAttribute('style', 'width: ' + document.getElementById('app').offsetWidth + 'px !important;')
        } else {
          header.classList.remove('sticky')
        }
      }
    }
  }
</script>

<style scoped>
  .f-headers {
    top: 0;
    /*position: fixed;*/
    width: 100%;
    z-index: 999;
  }

  .sticky {
    position: fixed;
    top: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/headerComponents/Headers.vue